import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.3, d: "m2 20-2-2 8-8-8-8 2-2 8 8 8-8 2 2-8 8 8 8-2 2-8-8z" }));
export default SvgCloseIcon;
